const ENVS = ["VUE_APP_BASE_URL"];

const env = () => {
	for (let i = 0; i < ENVS.length; ++i) {
		const env = ENVS[i];
		if (process.env[env] === undefined) {
			console.log(`Missing ${env} env`);
		}
	}
};

export default env;

export enum assessmentStatus {
	notAssessed,
	underassessed,
	fairlyAssessed,
	overAssessed
}